import type { ProjectApiTypes } from '@highlight-cp/project-api';

import getBoxCountForProductFromTestGroup from '../get-box-count-for-product-from-test-group';

/**
 * ### getTotalBoxCountForProduct
 *
 * @description
 * Calculates the total box count for a product across all test groups.
 * Sums up the box counts from each test group that includes the product.
 *
 * @param testGroups - Array of test groups to calculate from
 * @param productId - The ID of the product to calculate for
 * @returns The total box count for the product across all test groups
 */
const getTotalBoxCountForProduct = (
  testGroups: ProjectApiTypes.AudienceBuilderTestGroup[] | null | undefined,
  productId: string | number,
): number => {
  if (!testGroups) {
    return 0;
  }

  return testGroups.reduce((total, testGroup) => {
    return total + getBoxCountForProductFromTestGroup(testGroup, productId);
  }, 0);
};

export default getTotalBoxCountForProduct;
